import React from "react"
import { PopupProvider } from "@utilities"
import { ShopifyProvider } from "@utilities"

export const wrapRootElement = ({ element }) => (
  <ShopifyProvider>
    <PopupProvider>{element}</PopupProvider>
  </ShopifyProvider>
)
